<template>
    <router-link :to="to" class="nav-link" :class="{ 'nav-link--home': isHome }">
        <app-icon class="nav-link__icon" :name="icon" :scale="1.4" hidden />

        <span class="nav-link__content">
            <slot />
        </span>
    </router-link>
</template>

<script>
import AppIcon from '@/components/ui/Icon.vue'

export default {
    name: 'NavLink',

    components: { AppIcon },

    props: {
        to: { type: Object, required: true },
        icon: { type: String, required: true },
    },

    computed: {
        isHome () {
            return this.to.name.toLowerCase() === 'home'
        },
    },
}
</script>

<style lang="scss" scoped>
.nav-link {
    padding: $spacing-unit-6 0;
    background: $tertiary-color;
    border: none;
    text-align: center;
    border-radius: $default-border-radius;
    font-size: 1.12rem;
    position: relative;

    @include interaction {
        background: $button-default-hover;
        text-decoration: none;
    }

    @include media-breakpoint-down(md) {
        padding: $spacing-unit-18;
        border-radius: 0;
    }

    &__icon {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        left: $spacing-unit-12;

        @include media-breakpoint-down(md) {
            left: 0;
            right: 0;
        }
    }

    &__content {
        @include media-breakpoint-down(md) {
            display: none;
        }
    }

    &:not(.nav-link--home).router-link-active,
    &.router-link-exact-active {
        background: $secondary-color;
        color: $color-text-inverted;
    }
}
</style>
